import React, { useRef } from 'react';
var VeltNotificationsPanelSkeleton = function (props) {
    var isLoading = props.isLoading, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-skeleton", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "is-loading": [true, false].includes(isLoading) ? (isLoading ? 'true' : 'false') : undefined }, children));
};
export default VeltNotificationsPanelSkeleton;
